import { extendObservable, action } from 'mobx';

import VehicleApi from '../psuite-js/apis/delivery/vehicle';
import VehicleDeviceApi from '../psuite-js/apis/delivery/vehicle-device';

class VehicleStore {

    constructor() {
        extendObservable(this, {
            vehicle: {},
            has_error: false,
            fetching: false,
            is_fetched: false,
            fetch: action(this.fetch.bind(this)),
            reset: action(this.reset.bind(this)),

            success: false,
            creating: false,
            has_error_create: false,

            create: action(this.create.bind(this)),
        });
    }

    async fetch(vehicle_id) {
        this.fetching = true;
        this.has_error = false;
        this.is_fetched = false;

        const response = await VehicleApi.get(vehicle_id);

        if (response.status === 200) {
            const vehicle = response.data.data;

            this.vehicle = vehicle;
        } else {
            this.has_error = true;
        }

        this.is_fetched = true;
        this.fetching = false;
        return response;
    }

    reset() {
        this.has_error = false;
        this.fetching = false;
        this.is_fetched = false;
        this.vehicle = {};
        this.success = false;
        this.has_error_create = false;
    }

    async create(device, callback = () => {}) {
        this.creating = true;
        this.has_error_create = false;

        const response = await VehicleDeviceApi.create(device);

        if (response.status === 200) {
            this.success = true;
        } else {
            this.has_error_create = true;
        }

        this.creating = false;

        return response;
    }

}

export default new VehicleStore();



// WEBPACK FOOTER //
// ./src/stores/vehicle.js